
import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'LeadsIcon',
})
export default class LeadsIcon extends Vue {

}
